import { Component, Inject, OnInit } from '@angular/core';

import {
  MatLegacyDialog as MatDialog,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BaseComponent } from '@shared/base/base.component';

@Component({
  selector: 'app-notify-procured-carriers-dialog',
  templateUrl: './notify-procured-carriers-dialog.component.html',
  styleUrls: ['./notify-procured-carriers-dialog.component.scss'],
})
export class NotifyProcuredCarriersDialogComponent extends BaseComponent implements OnInit {
  notifyProcuredCarriersForm: FormGroup = new FormGroup({
    notifyProcuredCarriers: new FormControl(null, [Validators.required]),
  });

  ngOnInit() {}

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<NotifyProcuredCarriersDialogComponent>
  ) {
    super();
  }

  createProject(): void {
    const data: any = {
      notifyProcuredCarriers: this.notifyProcuredCarriersForm.get('notifyProcuredCarriers').value,
    };
    this.closeDialog(data);
  }

  closeDialog(data: any): void {
    this.dialogRef.close(data);
  }
}
